"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckInIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var CheckInIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M14.7326 3L21.2674 5C21.672 5 22 5.44772 22 6V18C22 18.5523 21.672 19 21.2674 19L14.7326 21C14.328 21 14 20.5523 14 20V4C14 3.44772 14.328 3 14.7326 3ZM16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11ZM10 15.1575V17H12V19.5H9C8.17157 19.5 7.5 18.8284 7.5 18V17.345L10 15.1575ZM7.5 10.3125L10 12.5L7.5 14.6875L6 16V14H3V11H6V9L7.5 10.3125ZM12 4.5V7H10V9.84246L7.5 7.65496V6C7.5 5.17157 8.17157 4.5 9 4.5H12Z" }))); };
exports.CheckInIcon = CheckInIcon;
